import { useEffect } from "react";
import { fetchSandboxResult } from "../features/Slice/sandboxResultSlice";
import { useDispatch } from "react-redux";

/**
 * @file Init.jsx, Control some initial settings (user authentication, language setting, etc.)
 *
 * @returns {JSX.Element}
 */

const Init = () => {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(fetchSandboxResult());
    }, []);
    return <></>;
};

export default Init;
